import { styled } from '@clickcease/cc-client-components-lib'
export const topNavHeight = '48px'

export const TopNavStyled = styled('div', {
  background: '$white',
  fontFamily: 'Open Sans',
  boxShadow: '$dropDown',
  borderRadius: '$medium',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '$4 $8',
  variants: {
    onTopAndActive: {
      true: {
        zIndex: 1000000,
        pointerEvents: 'auto',
        background: '#FFFFFF',
        borderRadius: '4px',
      },
    },
  },
})

export const VerticalSeparator = styled('div', {
  width: '1px',
  height: '60%',
  marginInline: '$4',
  background: '$lightNeutral',
  margin: '0 $6',
})

export const TopNavCurrentPage = styled('div', {
  display: 'flex',
  alignItems: 'center',
  '> *': {
    lineHeight: topNavHeight,
  },
})

export const TopNavUserWrapper = styled('div', {
  cursor: 'pointer',
  display: 'flex',
  marginLeft: '$8',
})

export const TopNavRightSide = styled('div', {
  fontWeight: '$l',
  fontSize: '$h5',
  display: 'flex',
  alignItems: 'center',
  ['img']: {
    marginLeft: '$16',
  },
})

export const TopNavUserName = styled('div', {
  fontWeight: '$l',
  fontSize: '$md',
  color: '$mainTextColor',
  margin: '0px 8px',
  marginInlineStart: '$10',
  minWidth: '90px',
  lineHeight: topNavHeight,
})

export const IconsRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '> :not(:last-child)': {
    marginInlineEnd: '$8',
  },
})

export const IconWrapper = styled('div', {
  fontSize: '$h3',
  cursor: 'pointer',

  '&:hover > *': {
    color: '$buttonHovered',
  },
})
